import { useEffect, useState } from "react";
import api from "../lib/api";
import VenueCard from "../components/VenueCard";
import MapView from "../components/MapView";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Search, Map as MapIcon, List } from "lucide-react";
import useSEO from "../lib/useSEO";

export default function Venues() {
  const [city, setCity] = useState("");
  const [q, setQ] = useState("");
  const [venues, setVenues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mobileView, setMobileView] = useState("list");

  useSEO({
    title: "Lieux événementiels",
    description:
      "Découvrez des lieux d'exception pour vos événements en France : salles de réception, lieux atypiques, espaces professionnels. Réservation en ligne sécurisée.",
  });

  const fetch = async () => {
    setLoading(true);
    const { data } = await api.get("/venues", { params: { city: city || undefined, q: q || undefined } });
    setVenues(data); setLoading(false);
  };

  useEffect(() => { fetch(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="mb-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <p className="text-label text-muted-foreground mb-3">Catalogue</p>
          <h1 className="font-heading font-light tracking-editorial text-4xl text-ink">Lieux événementiels</h1>
        </div>
        <div className="flex gap-1 lg:hidden bg-cream-100 p-1 rounded-md self-start">
          <button
            data-testid="venue-mobile-view-list"
            onClick={() => setMobileView("list")}
            className={`px-3 py-1.5 text-xs font-semibold rounded ${mobileView === "list" ? "bg-white shadow-sm text-ink" : "text-muted-foreground"}`}
          >
            <List className="h-4 w-4 inline mr-1" /> Liste
          </button>
          <button
            data-testid="venue-mobile-view-map"
            onClick={() => setMobileView("map")}
            className={`px-3 py-1.5 text-xs font-semibold rounded ${mobileView === "map" ? "bg-white shadow-sm text-ink" : "text-muted-foreground"}`}
          >
            <MapIcon className="h-4 w-4 inline mr-1" /> Carte
          </button>
        </div>
      </div>

      <div className="bg-white border border-ink/10 rounded-md p-4 mb-8 grid grid-cols-1 md:grid-cols-12 gap-3">
        <Input className="md:col-span-5" placeholder="Ville" value={city} onChange={(e) => setCity(e.target.value)} data-testid="venue-filter-city" />
        <Input className="md:col-span-5" placeholder="Mot-clé..." value={q} onChange={(e) => setQ(e.target.value)} data-testid="venue-filter-q" />
        <Button onClick={fetch} className="md:col-span-2 bg-ink hover:bg-ink/85 text-cream rounded-none" data-testid="venue-filter-apply">
          <Search className="h-4 w-4 mr-2" /> Rechercher
        </Button>
      </div>

      {loading ? <p>Chargement...</p> : venues.length === 0 ? (
        <p className="text-muted-foreground">Aucun lieu trouvé.</p>
      ) : (
        <>
          <p className="text-sm text-muted-foreground mb-4">{venues.length} lieu{venues.length > 1 ? "x" : ""}</p>

          <div className="hidden lg:grid lg:grid-cols-5 gap-6">
            <div className="lg:col-span-3 grid grid-cols-1 xl:grid-cols-2 gap-5 auto-rows-min">
              {venues.map((v) => <VenueCard key={v.id} venue={v} />)}
            </div>
            <div className="lg:col-span-2 sticky top-24 self-start" style={{ height: "calc(100vh - 7rem)" }}>
              <MapView items={venues} type="venue" />
            </div>
          </div>

          <div className="lg:hidden">
            {mobileView === "list" ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {venues.map((v) => <VenueCard key={v.id} venue={v} />)}
              </div>
            ) : (
              <div style={{ height: "calc(100vh - 22rem)", minHeight: "400px" }}>
                <MapView items={venues} type="venue" />
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
